import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  Paper as MuiPaper,
  Typography,
  Paper,
  Button,
  Dialog,
  Divider,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { styled } from "@mui/system";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStyles } from "../../../Styles/style";
import NotFound from "../../../../../../components/NotFound/NotFound";
import { useTranslation } from "react-i18next";
import Hours from "./Components/hours";
import EditModal from "../../Modal";
import CardHeader from "../CardHeader";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement="top-start"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1B2430",
    borderRadius: "8px",
  },
}));
const MoreOpeningHours = ({
  locationDetailsData,
  location,
  getLocationDetails,
  setLocationDetailsData,
  getLocationDetailsListing,
  locationCategory,
  lodgingCategories,
  categoryLoading,
  addPermission,
  editPermission,
  deletePermission,
  viewPermission,
  centerData,
  displayMapError,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openDefaultModel, setOpenDefaultModel] = useState(false);
  const [allData, setAllData] = useState([]);
  const [dataCount, setDataCount] = useState(3);

  const loadMoreData = () => {
    setDataCount(locationDetailsData?.result?.length);
  };
  const loadLessData = () => {
    setDataCount(3);
  };
  const handleOpenTemplateMenu = () => {
    setOpenDefaultModel(true);
  };
  const handleCloseTemplateMenu = () => {
    setOpenDefaultModel(false);
    getLocationDetails(location);
  };
  return (
    <>
      {openDefaultModel && (
        <EditModal
          open={openDefaultModel}
          modalIndex={6}
          onCancel={handleCloseTemplateMenu}
          locationDetailsData={locationDetailsData}
          location={location}
          getLocationDetails={getLocationDetails}
          setLocationDetailsData={setLocationDetailsData}
          getLocationDetailsListing={getLocationDetailsListing}
          locationCategory={locationCategory}
          lodgingCategories={lodgingCategories}
          categoryLoading={categoryLoading}
          centerData={centerData}
          displayMapError={displayMapError}
        />
      )}
      <Card variant="outlined" className={classes.listingCard}>
        {locationDetailsData !== null ? (
          <>
            <Grid container spacing={1}>
              <CardHeader
                title={t("More_Opening_Hours")}
                editPermission={editPermission}
                viewPermission={viewPermission}
                handleOpenTemplateMenu={handleOpenTemplateMenu}
              />

              <Grid item xs={12} sm={12} md={12} lg={12}>
                {locationDetailsData?.result?.google?.moreHours &&
                  locationDetailsData?.result?.google?.moreHours?.length > 0 &&
                  locationDetailsData?.result?.google?.moreHours
                    .slice(0, dataCount)
                    .map((moreHours) => (
                      <Grid container>
                        <Grid xs={12} sm={12} md={12} lg={12}>
                          <div>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography
                                  sx={{ padding: "8px" }}
                                  className={classes.accordianText}
                                >
                                  {moreHours?.hoursTypeId?.replaceAll("_", " ")}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container>
                                  <Hours
                                    location={location}
                                    locationDetailsData={locationDetailsData}
                                    item={moreHours}
                                  />
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                          <Divider />
                        </Grid>
                      </Grid>
                    ))}
              </Grid>
            </Grid>

            {locationDetailsData?.result?.google?.moreHours?.length > 3 ? (
              <>
                <Divider />
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ alignItems: "start", padding: "12px" }}
                >
                  {dataCount >= 3 ? (
                    <Button onClick={loadMoreData}>
                      <Typography className={classes.viewMoreButton}>
                        {t("View_More")}
                      </Typography>
                    </Button>
                  ) : (
                    <Button onClick={loadLessData}>
                      <Typography className={classes.viewMoreButton}>
                        {t("View_Less")}
                      </Typography>
                    </Button>
                  )}
                </Grid>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <NotFound text={t("No_Data_Found")} />
        )}
      </Card>
    </>
  );
};

export default MoreOpeningHours;
